module.exports = __webpack_public_path__ + "img/nettent.b574f35e.svg";